// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./src/gameboard.js");
__webpack_require__("./src/page.js");
__webpack_require__("./src/player.js");
var __webpack_exports__ = __webpack_require__("./src/ship.js");
